import { css } from "@emotion/react";
import type { PropsWithChildren } from "react";

import { getSpaceVariable } from "../space/utilities";

type ButtonsProps = PropsWithChildren;

export default function Buttons(props: ButtonsProps) {
    const { children } = props;

    const containerCss = css({
        display: "flex",
        justifyContent: "space-between",
        gap: getSpaceVariable(2),
    });

    return <div css={containerCss}>{children}</div>;
}
